import { ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";
import { BOOKING_URL, CONTACT } from "../lib/data";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="lilac-blur" style={{ bottom: "-300px", left: "-200px", opacity: 0.6 }} />

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-5">— Say Hello</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brown-dark leading-[1.05] tracking-tight">
              Let's get your pup on the <em className="italic text-lilac-dark">books</em>.
            </h2>
            <p className="mt-6 text-lg text-text-secondary max-w-lg">
              Bookings are made online for a smooth, real-time view of
              availability. For questions, quotes, or special requests, you're
              warmly welcome to get in touch.
            </p>

            <a
              href={BOOKING_URL}
              data-testid="contact-book-button"
              className="btn-primary mt-10"
            >
              Join The Waitlist
              <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-5">
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="contact-email-card"
              className="p-7 rounded-[2rem] bg-cream-alt border border-[#E6DEC3] hover:border-lilac transition-all group"
            >
              <Mail className="text-lilac-dark mb-5" size={22} />
              <div className="eyebrow mb-2">Email</div>
              <div className="font-serif text-lg text-brown-dark group-hover:text-lilac-dark transition-colors break-all">
                {CONTACT.email}
              </div>
            </a>

            <div
              data-testid="contact-location-card"
              className="p-7 rounded-[2rem] bg-brown-dark text-cream sm:col-span-2"
            >
              <MapPin className="text-lilac mb-5" size={22} />
              <div
                className="eyebrow mb-2"
                style={{ color: "rgba(249, 246, 240, 0.7)" }}
              >
                Studio Location
              </div>
              <p className="font-serif text-xl leading-snug">
                {CONTACT.location}
              </p>
              <p
                className="mt-3 text-sm"
                style={{ color: "rgba(249, 246, 240, 0.7)" }}
              >
                The exact address is emailed to you once your booking is
                confirmed.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
